export default function SectionTitle({ kicker, title, icon: Icon, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        {kicker && <div className="text-xs font-bold tracking-[0.2em] text-smasher-orange mb-1">{kicker}</div>}
        <h2 className="font-heading font-black uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight flex items-center gap-3">
          {Icon && <Icon className="w-7 h-7 text-smasher-gold" />}
          <span className="text-white">{title}</span>
        </h2>
      </div>
      {action}
    </div>
  );
}
